import { getPlainText } from "utilities/getPlainText"

export const getExcerpt = (richtext, maxLength = 320) => {
  let text

  if (richtext.type === "doc") {
    text = getPlainText(richtext, { addNewlines: false })
  } else {
    text = richtext
  }

  if (!text || !maxLength || text?.length < maxLength) {
    return text
  }

  return `${text?.substring(0, maxLength)}…`
}
